module.exports = __webpack_public_path__ + "media/comboSmash-highScores@lg-744c76c42fecf255f84ea655f313e6a9.jpg";